import { ThemeProvider } from 'styled-components'
import React, { ReactElement, ReactNode, useRef } from 'react'
import { changeFontelloConfig, FontelloConfig } from '../../Fontello'

export interface BaseTheme {
    breakpoints?: string[]
}

export interface UniversalProviderProps<T> {
    children?: ReactElement | ReactNode
    fontelloConfig?: FontelloConfig
    theme: T
}

const UniversalProvider = <T extends BaseTheme>(props: UniversalProviderProps<T>): ReactElement => {
    const { theme, children, fontelloConfig } = props
    const initial = useRef<boolean>(true)

    if (initial.current && fontelloConfig) {
        initial.current = false
        changeFontelloConfig(fontelloConfig)
    }

    return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}

export default UniversalProvider
